import './ProductPhotos.scss';
import Component from './ProductPhotos.js';
export default Component;
